import { detect } from 'detect-browser';
export default function setBrowserClass() {
    const blocksSchedule = document.querySelector('.schedule-blocks');
    const browser = detect();
    if (blocksSchedule && browser) {
        blocksSchedule.classList.add(browser.name);
    }
}
